import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Paperclip } from "lucide-react";
import { Storico, apriAllegato } from "@/components/RichiestaCampi";

const STATI = { in_attesa: ["In attesa", "bg-amber-100 text-amber-800"], chiarimenti: ["Chiarimenti richiesti", "bg-sky-100 text-sky-800"], approvata: ["Approvata", "bg-emerald-100 text-emerald-700"], rifiutata: ["Rifiutata", "bg-red-100 text-red-700"] };

function Card({ r, onDone }) {
  const [risp, setRisp] = useState("");
  const [l, c] = STATI[r.stato] || STATI.in_attesa;
  const invia = async () => {
    try { await api.post(`/richieste/${r.kind}/${r.id}/risposta`, { risposta: risp }); toast.success("Risposta inviata: la richiesta torna in Da approvare"); onDone(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid={`mia-richiesta-${r.kind}-${r.id}`} className="card-immo p-4">
      <div className="flex items-start gap-2 flex-wrap">
        <div className="flex-1 min-w-[200px] text-sm font-semibold">{r.link ? <Link to={r.link} className="hover:underline">{r.titolo}</Link> : r.titolo}</div>
        <span data-testid={`mia-richiesta-stato-${r.id}`} className={`px-2.5 py-1 rounded-full text-[11px] font-bold ${c}`}>{l}</span>
      </div>
      {r.richiesta?.motivazione && <p className="text-xs text-[var(--muted)] mt-1 line-clamp-3">{r.richiesta.motivazione}</p>}
      {r.nota && <p data-testid={`mia-richiesta-nota-${r.id}`} className="text-xs mt-2 rounded-lg bg-slate-50 border border-[var(--border)] p-2"><b>Nota di chi ha deciso:</b> {r.nota}</p>}
      {(r.richiesta?.allegati || []).map((a) => <button key={a.id} onClick={() => apriAllegato(a)} className="mr-2 mt-1 inline-flex items-center gap-1 text-xs text-[#B8369F]"><Paperclip size={11} />{a.nome}</button>)}
      <Storico items={r.chiarimenti} />
      {r.stato === "chiarimenti" && <div className="mt-2">
        <textarea data-testid={`mia-richiesta-risposta-${r.id}`} value={risp} onChange={(e) => setRisp(e.target.value)} rows={3} placeholder="Rispondi alla domanda…" className="w-full px-3 py-2 rounded-lg border border-[var(--border)] text-sm" />
        <button data-testid={`mia-richiesta-invia-${r.id}`} disabled={!risp.trim()} onClick={invia} className="mt-1 px-4 py-2 rounded-lg bg-[#FC82ED] text-black text-sm font-semibold disabled:opacity-40">Invia risposta</button>
      </div>}
    </div>
  );
}

export default function LeMieRichieste() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/richieste/mie").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  return (
    <div className="max-w-2xl mx-auto px-4 py-6" data-testid="le-mie-richieste-page">
      <h1 className="font-display text-2xl font-extrabold flex items-center gap-2 mb-1"><FileText size={22} className="text-[#FC82ED]" /> Le mie richieste</h1>
      <p className="text-sm text-[var(--muted)] mb-5">Prezzi di pubblicazione, sconti provvigione e spese che hai mandato in approvazione.</p>
      {!items ? <div className="skeleton h-32 rounded-2xl" /> : !items.length ? <p className="text-sm text-[var(--muted)]">Nessuna richiesta.</p> :
        <div className="space-y-2">{items.map((r) => <Card key={`${r.kind}-${r.id}`} r={r} onDone={load} />)}</div>}
    </div>
  );
}
